"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _message = _interopRequireDefault(require("../message"));
var _exception = _interopRequireDefault(require("../_util/exception"));
var _localeContext = require("../locale-context");
var defaultFeedback = {
  loadSuccess: function loadSuccess(_result) {},
  loadFailed: function loadFailed(error) {
    _message["default"].error((0, _exception["default"])(error, (0, _localeContext.$l)('DataSet', 'query_failure')));
  },
  submitSuccess: function submitSuccess(_result) {
    _message["default"].success((0, _localeContext.$l)('DataSet', 'submit_success'));
  },
  submitFailed: function submitFailed(error) {
    _message["default"].error((0, _exception["default"])(error, (0, _localeContext.$l)('DataSet', 'submit_failure')));
  }
};
var _default = defaultFeedback;
exports["default"] = _default;